const data = [
    { id: 1, name: "Pendente" },
    { id: 2, name: "Cancelado" },
    { id: 3, name: "Concluído" },
    { id: 4, name: "Em andamento" },
    { id: 5, name: "Confirmado" },
  ];
  
  export default [...data];
  